import { createHeimdallAuthClient } from '@highlight-cp/auth-client/heimdall-client';
import { createHeimdallSession } from '@highlight-cp/auth-client/heimdall-session';

// Rechecks the Heimdall session alone: a guest has none, so a guest's 401 changes nothing here.
export const {
  HeimdallSessionProvider,
  sessionRecheckMiddleware,
  useHeimdallClient,
  useHeimdallSession,
} = createHeimdallSession(createHeimdallAuthClient);
